import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchInquiryStats() {
  const { data } = await http("/admin/inquiry-stats");

  return data;
}

export function useInquiryStats(id) {
  const { data, ...raResult } = useQuery(["inquiry-stats"], () =>
    fetchInquiryStats()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
